import WorldMap from "./WorldMap";

export default function Coverage() {
  return (
    <section className="py-24 lg:py-32 bg-bg">
      <div className="max-w-7xl mx-auto px-6 lg:px-10">
        <div className="text-center max-w-2xl mx-auto mb-14">
          <span className="text-cyan text-xs font-mono-tech tracking-[0.2em] uppercase mb-4 block">
            Alcance Global
          </span>
          <h2 className="text-white text-3xl lg:text-5xl font-bold mb-4">
            Onde a Serra Consultoria atua
          </h2>
          <p className="text-white/55 text-base lg:text-lg">
            Projetos entregues para clientes no Brasil, Argentina, Paraguai,
            Portugal, Escócia e Itália.
          </p>
        </div>

        <div className="max-w-3xl mx-auto">
          <WorldMap />
        </div>
      </div>
    </section>
  );
}
